import { actions } from "../../actions/basket/basket";

export default function purchases( initialState = {}, action ) {
    const newState = { ...initialState };

    switch( action.type ) {
        case actions.ADD_TO_BASKET: return addToBasket( newState, action.product );
        case actions.SET_ALL_PRODUCTS: return setAllProducts( newState, action.products );
        case actions.GET_BASKET_PRODUCTS: return getBasketProducts( newState );
        case actions.REMOVE_FROM_BASKET: return removeProductFromBasket( newState, action.product );
        case actions.CLEAR_BASKET: return clearBasket( newState, action.products );
        case actions.SET_ALL_PACKAGES: return setAllPackages( newState, action.packages );
        default: return newState;
    }
}

function setAllProducts( newState, products ) {
    newState.products = products;
    return newState;
}

function setAllPackages( newState, packages ) {
    newState.packages = packages;
    return newState;
}

function getBasketProducts( newState ) {
    if( !newState.basket ) {
        newState.basket = [];
    }

    return newState;
}

function addToBasket( newState, product ) {

    if( !newState.basket ) {
        newState.basket = [];
    }else{
        newState.basket = [ ...newState.basket ];
    }

    const productAlreadyInBasket = newState.basket.filter( ( basket ) => { return basket.id  === product.id } );

    if( productAlreadyInBasket.length === 0 ) {
        product.in_basket = true;
        newState.basket.push( product );
    }

    return newState;
}

function removeProductFromBasket( newState, product ) {

    let basket = [ ...newState.basket ];

    const removedItem = newState.basket[product].id;

    let products = [ ...newState.products ];

    const updateProduct = products.filter( ( product, index ) => { return product.id === removedItem } );

    updateProduct[0].in_basket = false;

    basket = basket.filter( ( item, index ) => { return index !== product; } );

    newState.basket = basket;
    newState.products = products;
    
    return newState;
}

function clearBasket( newState ) {
    newState.basket = [];

    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/basket/purchases.js